import eventBus from "./events.js";
import Filters from "./filters.js";
import {getAttendeeName, selectAttendeeFromDropdown} from "./attendee-dropdowns.js";
import dialog from "./dialog.ts";

const $ = window.jQuery;

/**
 * Handle the admin bar if it is present.
 */
const adminBar = (() => ({
    present() {
        return $('#wpadminbar').length > 0;
    },
    hide() {
        if (!this.present()) return;
        $('#wpadminbar').hide();
        document.documentElement.style.setProperty('margin-top', '0', 'important');
    },
    show() {
        if (!this.present()) return;
        $('#wpadminbar').show();
        document.documentElement.style.removeProperty('margin-top');
    }
}))();

function renderExpanders() {
    $(`<div class="bundle_form_expand frButtonGroup"></div>`).appendTo($('.product-header', this));
}

function renderAddAttendeeButton() {
    const $product = $(this);
    $product.find('.add-bundle-attendee').remove();

    if ($product.hasClass('-collapsed')) return;

    $product.find('.bundle_data').before(`<button class="frButton -sticky-bottom-left add-bundle-attendee"><span class="icon-user-plus"></span><span>${FestivalI18n.add_bundle_attendee}</span></button>`);
}

function renderSelectedAttendeeButton() {
    const $product = $(this);
    $product.find('.add-bundle-attendee').remove();

    if ($product.hasClass('-collapsed')) return;

    const attendee = getAttendeeName($product.find('.blank-attendee-details .attendee-dropdown').val());
    $product.find('.bundle_data').before(`<button class="frButton -sticky-bottom-left add-bundle-attendee"><span class="icon-user-check"></span> <span>${FestivalI18n.configuring_package_for} ${attendee}</span></button>`);
}

/**
 * @this {HTMLElement}
 */
function renderShowPackageButton() {
    const text = FestivalI18n.view_bundle.replace(':count', $(this).children('.bundled_product').length);
    $(this).find('.bundle_form_expand').html(`<button class="frButton toggle-bundle-details">${text}</button>`).appendTo($('.product-header', this));
    $(this).find('.add-bundle-attendee').remove();
}

function renderHidePackageButton() {
    $(this).find('.bundle_form_expand').html(`<button class="frButton -icon -blank toggle-bundle-details"><span class="icon-x"></span></button>`);
}

function productHasNextAttendeeConfigured($product) {
    return /^\d+$/.test($product.find('.blank-attendee-details .attendee-dropdown').val());
}

function resetBlankAttendee($product) {
    $product.find('.blank-attendee-details .attendee-dropdown').val('').trigger('change').addClass('-invalid');
    renderAddAttendeeButton.call($product);
}

function updateAttendeeCTAButton($product, content) {
    $product.find('.blank-attendee-details .frDialog-footer button').html(content);
}

function resetAttendeeCTAButton($product) {
    updateAttendeeCTAButton($product, `<span>${FestivalI18n.configure_package_attendee_button}</span>`);
}

function getInputType($input) {
    if ($input.prop('tagName') === 'INPUT') {
        return $input.attr('type');
    }

    if ($input.prop('tagName') === 'SELECT') {
        return 'select';
    }

    return undefined;
}

function storeDefaultProductBundleConfiguration() {
    $('.product-type-bundle input, .product-type-bundle select').not('[type="hidden"]').each(function () {
        const type = getInputType($(this));
        switch (type) {
            case 'checkbox':
            case 'radio':
                $(this).data('default-checked', $(this).prop('checked'));
                break;
            case 'select':
            case 'text':
            default:
                $(this).data('default-value', $(this).val());
        }
    });
}

function resetProductBundleConfiguration($product) {
    $('.product-quantity input, .product-quantity select', $product).not('[type="hidden"]').each(function () {
        const type = getInputType($(this));
        switch (type) {
            case 'checkbox':
            case 'radio':
                $(this).prop('checked', $(this).data('default-checked'));
                break;
            case 'select':
            case 'text':
            default:
                $(this).val($(this).data('default-value'));
        }
    });
}

function resetProductBundle($product) {
    resetProductBundleConfiguration($product);
    renderAddAttendeeButton.call($product);
}

/**
 * @this {Element}
 */
function displayAttendeesOnOpenBundle() {
    const $product = $(this);
    const id = $product.data('product-id');
    const $details = $product.find('.product-details');
    $details.find('.bundle-attendee-tickets').remove(); // Remove any existing attendees
    $('.bundle-attendee-tickets[data-product-id="' + id + '"]').appendTo($details);
    $details.find('.return-to-bundles').remove();
    $details
        .append('<div class="frButton -action -big return-to-bundles toggle-bundle-details">' + FestivalI18n.close_bundle_continue + '&nbsp;<span class="icon-arrow-right"></span></span></div>');
}

/**
 * @this {Element}
 */
function returnAttendeesToSummary() {
    $(this).find('.fooevents-tickets-group').appendTo($('#fooevents_order_notes_page_load'));
}

function closeParentBundle() {
    closeBundle.call($(this).closest('.single-product'));
}

/**
 * @this {Element}
 */
function openBundle() {
    $(this)
        .addClass('-open')
        .removeClass('-collapsed')
    renderHidePackageButton.call(this);
    renderAddAttendeeButton.call(this);
    displayAttendeesOnOpenBundle.call(this);
    $(this).find('.summary')[0].scrollIntoView({behavior: 'smooth'});

    /*
     * If product has advanced descriptions display them on optional products in bundle
     * even if they're not selected.
     */
    $('.wc-pao-addon-has-description').each(function () {
        $(this).closest('.bundled_item_cart_content').show();
    });

    $('.wc-pao-addon-has-description input').on('input', function () {
       if (this.type && ['radio', 'checkbox'].indexOf(this.type) > -1 && this.checked) {
            const id = $(this).closest('.wc-pao-addon-has-description').data('addon-id');
            $(`input[name="bundle_selected_optional_${id}"]`).attr('checked', true);
       }
    });

    adminBar.hide();
    $('body')
        .css('overflow', 'hidden')
        .addClass('product-bundle-is-open');
}

function attachAttendeesToOpenBundleOnAttendeeReload() {
    $('.single-product.-open').each(displayAttendeesOnOpenBundle);
}

/**
 * @this {Element}
 */
function closeBundle() {
    $(this)
        .addClass('-collapsed')
        .removeClass('-open');
    renderShowPackageButton.call(this);
    returnAttendeesToSummary.call(this);
    $(this).find('.return-to-bundles').remove();

    adminBar.show();
    $('body')
        .css('overflow', '')
        .removeClass('product-bundle-is-open');
}

function initializeBundlesUI() {

    storeDefaultProductBundleConfiguration();

    const $bundles = $('.product-type-bundle').closest('.event-product');
    $bundles.each(renderExpanders).each(closeBundle);

    $('.event-product .bundle_button .quantity').hide();

    $('.blank-attendee-details').on('close', function () {
        if (this.returnValue === 'continue') {
            $(this).find('.save-attendee').trigger('click');
        }
    });

    const $body = $('body');

    $body.on('change', '.blank-attendee-details .attendee-dropdown', function () {
        $(this).closest('form').find('.js-select-attendee-continue').prop('disabled', this.value === '');
    });

    $body.on('click', '.add-bundle-attendee', function () {
        const $product = $(this).closest('.single-product');
        const $attendeeForm = $product.find('.blank-attendee-details');
        if ($attendeeForm.length > 0) {
            resetAttendeeCTAButton($product);
            $attendeeForm[0].showModal();
        }
    })
        .on('click', '.product-type-bundle .toggle-bundle-details', function () {
            const $product = $(this).closest('.single-product');

            const open = !$product.hasClass('-collapsed');
            if (open && productHasNextAttendeeConfigured($product)) {
                const guard = dialog({
                    title: 'Unsaved Attendee Details',
                    content: `<p>You have selected an attendee, but you have not added them to your cart. If you close this package, your changes will be lost.</p>`,
                    footer: `<div style="display: flex;justify-content: space-evenly;"><button class="frButton -warning continue-close">Discard Changes</button><button class="frButton">Continue Editing</button></div>`,
                    blockUI: true,
                    cssClass: '-mw-400',
                });
                guard.$el.appendTo('body');
                guard.$el.on('click', '.frButton', function () {
                    guard.close();
                    if ($(this).hasClass('continue-close')) {
                        continueToggle();
                    }
                });
                guard.show();

            } else {
                continueToggle();
            }

            function continueToggle() {
                $bundles.each(closeBundle);

                if (!open) {
                    openBundle.call($product);
                } else {
                    // Scroll to parent product when closing to resume scrolling
                    $product[0].scrollIntoView(true);
                }
            }


        });

    /**
     * When adding to cart check an attendee has been selected. If not, open the attendee form.
     *
     * Once selected and closed, trigger the click event again on the add to cart button.
     */
    $('.event-product .bundle_add_to_cart_button').on('click', function (e) {
        const $btn = $(this);
        const $product = $(this).closest('.single-product');
        if (!productHasNextAttendeeConfigured($product)) {
            e.preventDefault();
            e.stopImmediatePropagation();

            updateAttendeeCTAButton($product, `<span>${FestivalI18n.select_attendee_and_add_to_cart}</span>`);
            $product.find('.blank-attendee-details')[0].showModal();
            $product.find('.blank-attendee-details').one('close', function () {
                if (productHasNextAttendeeConfigured($product) && this.returnValue === 'continue') {
                    $btn.trigger('click');
                }
            });
            return false;
        }

        Filters.add('ajax_response', function (data, args, options) {
            if (data.result === 'success') {
                data.messages = '';
            }

            options.delete = true;
            return data;
        });

        const addingToCart = dialog({
            title: FestivalI18n.adding_to_cart,
            content: '<span class="icon-spinner frSpinner"></span>',
            blockUI: true,
            cssClass: '-loading',
        });
        addingToCart.$el.appendTo('body').data('product_id', $product.data('product-id'));
        addingToCart.show();

        const selected = $product.find('.blank-attendee-details .attendee-dropdown').val();
        eventBus.one('attendee_dropdowns_initialized', function () {
            const id = $product.data('product-id');
            const latestDropdown = $product.find(`.attendee-dropdown[id*="attendee-${id}"]`).last();
            latestDropdown.val(selected).trigger('change');
            selectAttendeeFromDropdown.call(latestDropdown);
        });

        eventBus.one('cart_change:stop', function (event, ajaxCompleteEvent, xhr) {
            if (xhr.responseJSON.result === 'failure') {
                addingToCart.close();
                return;
            }

            addingToCart.title(FestivalI18n.added_to_cart);
            addingToCart.content(`<button class="add-another-attendee frButton -full">Add another attendee</button>
<button class="close-continue frButton -full -secondary">Continue</button>`);
        });
    });

    $body.on('click', '.add-another-attendee', function () {
        const dialog = $(this).closest('.frDialog');
        dialog.data('dialog').close();
        const product = $(`#product-${dialog.data('product_id')}`);
        if (product.length > 0) {
            product[0].scrollIntoView(true);
            resetProductBundle(product);
        }
    }).on('click', '.close-continue', function () {
        const dialog = $(this).closest('.frDialog');
        dialog.data('dialog').close();
        const product = $(`#product-${dialog.data('product_id')}`);
        resetProductBundle(product);
    }).on('change', '.blank-attendee-details .attendee-dropdown', function () {
        const product = $(this).closest('.single-product');
        if (productHasNextAttendeeConfigured(product)) {
            renderSelectedAttendeeButton.call(product);
        } else {
            renderAddAttendeeButton.call(product)
        }
    });

    eventBus.on('attendee_dropdowns_initialized', function () {
        $('.event-product').each(function () {
            resetBlankAttendee($(this));
        });
    });


    /*
        Default to the first radio for each bundle product if none already selected,
        otherwise WC will complain about missing required fields on optional bundle products.
     */
    $('.wc-pao-addon-radio').each(function () {
        const name = $(this).attr('name');
        const restrictions = $(this).data('restrictions') || {};
        if ($(`input[name="${name}"]:checked`).length === 0 && (restrictions.required && restrictions.required === 'yes' || $(this).is(':required'))) {
            $(`input[name="${name}"]`).first().prop('checked', true);
        }
    });

    function collapsePackageContentsOnSmallDevices() {
        $('.bundle-attendee-tickets-configuration').each(function () {
            const $conf = $(this);
            const $fields = $conf.parent().find('.bundle-attendee-fields');
            // elements are stacked
            if ($conf.offset().top !== $fields.offset().top) {
                $conf.find('ul > li').slice(2).hide();
                $conf.find('> ul').append(`<li class="display-ticket-config"><button class="frButton -small -compact -secondary">${FestivalI18n.view_ticket_config}</button></li>`);
            }
        });
    }

    $body.on('click', '.display-ticket-config', function () {
        $(this).parent().find('li').show();
        $(this).remove();
    }).on('click', '.product-type-bundle .opc-complete-order', closeParentBundle);

    eventBus.on('attendees_reload', function () {
        collapsePackageContentsOnSmallDevices();
        attachAttendeesToOpenBundleOnAttendeeReload();
    });
}

export default initializeBundlesUI;
